import { TfgFeedsColumns } from '../../../services/column-definitions';

export const getDataGridProps = () => ({ rows: [], columns: TfgFeedsColumns() });
